import { render } from "./ProteinGraph.vue?vue&type=template&id=761518d2"
import script from "./ProteinGraph.vue?vue&type=script&lang=js"
export * from "./ProteinGraph.vue?vue&type=script&lang=js"

import "./ProteinGraph.vue?vue&type=style&index=0&id=761518d2&lang=css"

import exportComponent from "/home/mihai/repos/skinscience/skinatlas/src/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__